import { Tooltip } from "@mui/material";

export const renderCellContent = (content) => {
    const isLongText = typeof content === 'string' && content.length > 50;

    return isLongText ? (
      <Tooltip title={content} arrow>
        <span style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'inline-block',
          maxWidth: '150px'
        }}>
          {content}
        </span>
      </Tooltip>
    ) : (
      content
    );
  };